module.exports = __webpack_public_path__ + "static/media/talent_diamondb4ca42a00a8aa83439191687d52941dd.webp";